import { Component, OnInit } from '@angular/core';
import { CONFIG } from 'src/config/config';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  homepage = CONFIG.appUrl;

}
